import React, { useEffect, useState } from "react";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import mainImg from "../../../assets/images/Home/main-img.png";
import { Container } from "react-bootstrap";
import Pagination from "../../components/Pagination";
import { FaChevronRight } from "react-icons/fa";
import DOMPurify from "dompurify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Blog = () => {
  const [Bloglist, setBloglist] = useState([]);
  const [imagePath, setImagePath] = useState(""); // for base image path
  const [status, setstatus] = useState("");
  const [fooder, setfooder] = useState("");
   const [bgImage, setBgImage] = useState("");
  const navigate = useNavigate();
  // for base image path
  useEffect(() => {
    fetchBlogList();
    footerdata();
    bannerimg();
  }, []);

  const fetchBlogList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/blog-list`
      );
      setBloglist(response.data?.data || []);
      setImagePath(response.data?.imagePath || "");
      setstatus(response.data?.status);
    } catch (error) {
      console.error("Blog list fetch error:", error);
    }
  };
  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      // setstatus(res.data.status);
    } catch (error) {}
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const totalPages = Math.ceil(Bloglist.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const blogsall = Bloglist.slice(startIndex, startIndex + itemsPerPage);

  // Function to limit to 50 words
  const getTrimmedHTML = (html, wordLimit = 50) => {
    // Strip HTML tags to count words
    const textOnly = html.replace(/<[^>]+>/g, "");
    const words = textOnly.split(/\s+/).slice(0, wordLimit);
    const trimmedText = words.join(" ") + "...";

    // Optional: sanitize before inserting back
    const cleanHTML = DOMPurify.sanitize(trimmedText);
    return { __html: cleanHTML };
  };
  const handleReadMore = (id) => {
    localStorage.setItem("selectedBlogId", id);
    navigate("/blog-detail");
  };


    const bannerimg = async () => {
            try {
              const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
              );
        
              const baseUrl = res.data.imagePath;
              const courseImage = res.data.home_setting[0]?.course_image;
        
              // Full image URL
              const fullUrl = baseUrl + courseImage;
        
              setBgImage(fullUrl);
            } catch (error) {
              console.error("Error fetching banner:", error);
            }
          };
  return (
    <>
      <section className="course blog">
        <div className="page_header"></div>
        <div className="rs-breadcrumbs breadcrumbs-overlay">
          <div className="breadcrumbs-img">
                  <img src={bgImage} alt="Breadcrumbs bg" />
          </div>
          <div className="breadcrumbs-text white-color">
            <h1 className="page-title">Blogs</h1>
          </div>
        </div>
        {fooder.blogpermission == 1 ? (
          <Container>
            <div className="row py-60">
              {blogsall.map((blog, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="blog_card mb-24">
                    <div className="blog_card_img_block">
                      <img
                        src={
                          blog?.image ? `${imagePath}${blog.image}` : mainImg
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = mainImg;
                        }}
                        alt={blog?.title || "Blog Image"}
                      />
                      <p className="date">{blog.date}</p>
                    </div>
                    <div className="blog_card_text_block">
                      <h5 className="mb-8">
                        <a className="blog_title" href={blog.link}>
                          {blog.title}
                        </a>
                      </h5>
                      <p
                        className="mb-24"
                        dangerouslySetInnerHTML={getTrimmedHTML(
                          blog.description
                        )}
                      ></p>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="author d-flex align-items-center gap-2">
                          <img
                            src={
                              blog?.auth_image
                                ? `${imagePath}${blog.auth_image}`
                                : mainImg
                            }
                            alt="Author"
                          />
                          <h6 className="dark-gray mb-0">{blog.auth_name}</h6>
                        </div>
                        {/* <Link
                          to="/blog-detail"
                          className="h6 color-primary educate_link_btn"
                           onClick={() => handleReadMore(blog.id)}
                        >
                          Read More <FaChevronRight />
                        </Link> */}
                        <button
                          className="h6 color-primary educate_link_btn "
                          onClick={() => handleReadMore(blog.id)}
                        >
                          Read More <FaChevronRight />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={totalPages}
                />
              )}
            </div>
          </Container>
        ) : (
          ""
        )}
      </section>
    </>
  );
};

export default Blog;
